/**
 * Page configuration per shopping center.
 * SOV = Sicilia Outlet Village, TOV = Torino Outlet Village.
 */
export const DEFAULT_CENTER_KEY = 'sov';

/** Valid route slugs for vacancies pages (SOV and TOV only). */
export const VALID_CENTER_KEYS = ['sov', 'tov'];

export function isValidCenter(slug) {
  return slug != null && VALID_CENTER_KEYS.includes(slug.toLowerCase());
}

export const VACANCIES_PAGE_CONFIG = {
  sov: {
    logoUrl: '/images/logo-sicilia-outlet-village.png',
    logoLinkUrl: 'https://www.siciliaoutletvillage.com/it/',
    logoAlt: 'Sicilia Outlet Village',
    heroImageUrl: '/images/sov-main-vacancies.jpg',
    heroImageAlt: 'Sicilia Outlet Village',
    pageTitle: 'Lavora a Sicilia Outlet Village',
    paragraphs: [
      "Sicilia Outlet Village è la principale shopping destination dell'isola, gode di una posizione strategica essendo collocato nel cuore della Sicilia e facilmente raggiungibile da tutte le principali località della Sicilia.",
      'Il Village riunisce oltre 140 negozi dei più prestigiosi brand del lusso italiano e internazionale, e diversi',
      "punti ristoro, all'interno di un'ambiente di lusso, dinamico, rivolto ad assicurare una shopping experience unica e d'eccellenza.",
      'Il Village rappresenta anche un ambiente dove crescere professionalmente a contatto con i brands italiani ed internazionali di maggior prestigio e notorietà.',
      "Le aziende partner presenti all'interno di Sicilia Outlet Village sono alla ricerca di figure professionali e motivate per garantire la miglior gestione dei punti vendita e punti ristoro presenti nel Village.",
      "Di seguito puoi trovare l'elenco delle posizioni aperte ed i contatti a cui trasmettere la tua candidatura.",
    ],
  },
  tov: {
    logoUrl: '/images/logo-torino-outlet-village.png',
    logoLinkUrl: 'https://www.torinooutletvillage.com/it',
    logoAlt: 'Torino Outlet Village',
    heroImageUrl: '/images/tov-main-vacancies.jpg',
    heroImageAlt: 'Torino Outlet Village',
    pageTitle: 'Lavora a Torino Outlet Village',
    paragraphs: [
      'Torino Outlet Village è la principale shopping destination dell’area, a soli dieci minuti dal centro della città di Torino e dall’aeroporto di Caselle, gode di una posizione strategica essendo al centro dei flussi di traffico dal Nord Italia, Francia e Svizzera.',
      'Il Village riunisce 90 negozi monomarca dei più prestigiosi brand del lusso italiano e internazionale, e diversi punti ristoro, all’interno di un’ambiente di lusso, dinamico, rivolto ad assicurare una shopping experience unica e d’eccellenza.',
      'Il Village rappresenta anche un ambiente dove crescere professionalmente a contatto con i brands italiani ed internazionali di maggior prestigio e notorietà.',
      'Le aziende partner presenti all’interno di Torino Outlet Village sono alla ricerca di figure professionali e motivate per garantire la miglior gestione dei punti vendita e punti ristoro presenti nel Village.',
      'Di seguito puoi trovare l’elenco delle posizioni aperte ed i contatti a cui trasmettere la tua candidatura.',
    ],
  },
};

export function getConfigForCenter(centerSlug) {
  const key = centerSlug?.toLowerCase();
  return (
    VACANCIES_PAGE_CONFIG[key] ?? VACANCIES_PAGE_CONFIG[DEFAULT_CENTER_KEY]
  );
}
